/**
 * 가상 체험 선택 — 학부모 / 학원 두 카드를 위아래로 표시
 * 카드 클릭 → /demo/parent | /demo/owner (DemoIntroPage)
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IoArrowBack } from 'react-icons/io5';

const DemoChoicePage = () => {
  const navigate = useNavigate();

  return (
    <Wrap>
      <TopBar>
        <BackBtn onClick={() => navigate(-1)}><IoArrowBack size={22} /></BackBtn>
        <TopTitle>가상 체험</TopTitle>
      </TopBar>

      <Inner>
        <Lead>
          궁금한 쪽을 선택하면<br />
          <strong>로그인 없이 바로</strong> 체험할 수 있어요
        </Lead>

        <TrialList>
          <TrialCard type="button" onClick={() => navigate('/demo/parent')}>
            <TrialLabel>학부모 가상 체험</TrialLabel>
            <TrialTitle>내 아이 학원 생활을<br />한곳에서</TrialTitle>
            <TrialDesc>출석·과제·성적·공지를 보호자 입장에서 둘러보세요.</TrialDesc>
          </TrialCard>

          <TrialCard type="button" onClick={() => navigate('/demo/owner')}>
            <TrialLabel>학원 가상 체험</TrialLabel>
            <TrialTitle>학원·교습소 관리를<br />엄청 쉽고 편하게</TrialTitle>
            <TrialDesc>수업·학생·출석·일정까지 원장 화면을 직접 만져보세요.</TrialDesc>
          </TrialCard>
        </TrialList>
      </Inner>
    </Wrap>
  );
};

export default DemoChoicePage;

const Wrap = styled.div`
  min-height: 100vh;
  background: #fff;
`;

const TopBar = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider};
`;

const BackBtn = styled.button`
  background: none;
  display: flex;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const TopTitle = styled.p`
  font-size: 17px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Inner = styled.div`
  max-width: 480px;
  margin: 0 auto;
  padding: 20px 16px 32px;
`;

const Lead = styled.p`
  font-size: 15px;
  line-height: 1.55;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 18px;
  strong {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 800;
  }
`;

const TrialList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TrialCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 9px;
  padding: 20px 18px;
  border-radius: 16px;
  text-align: left;
  background: #fff;
  border: 1px solid ${({ theme }) => theme.colors.border};
`;

const TrialLabel = styled.span`
  padding: 4px 10px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
  background: #F4F5F7;
`;

const TrialTitle = styled.p`
  font-size: 18px;
  font-weight: 800;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const TrialDesc = styled.p`
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
